import PropTypes from 'prop-types'
import React from 'react'

export default function IconSchools({ className }) {
  return (
    <span
      className={`${className} main-icon-container main-icon-container-schools`}
    >
      <svg
        className="main-icon main-icon-schools"
        viewBox="0 0 80 80"
        enableBackground="new 0 0 80 80"
      >
        <g>
          <rect x="15.666" y="32.333" width="4.667" height="26.334" />
          <rect x="30.333" y="32.333" width="4.667" height="26.334" />
          <rect x="59.667" y="32.333" width="4.667" height="26.334" />
          <rect x="45" y="32.333" width="4.667" height="26.334" />
        </g>
        <polygon points="40,30.332 10.865,30.332 25.432,20.083 40,9.833 54.568,20.083 69.135,30.332 " />
        <rect x="13.583" y="60.667" width="52.835" height="2" />
        <rect x="10.625" y="64.5" width="58.75" height="2" />
      </svg>
      <span>
        Schulart
      </span>
    </span>
  )
}

IconSchools.propTypes = {
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/IconSchools.js